export default function Teams({ chartData, teamFilter, setTeamFilter }) {
  return (
    <div>

      <label>
        <input
          type="radio"
          name="teamFilter"
          value="Den Bosch O17"
          checked={teamFilter === "Den Bosch O17"}
          onChange={(e) => setTeamFilter(e.target.value)}
        />
        Alleen Den Bosch Spelers
      </label>
      <label>
        <input
          type="radio"
          name="teamFilter"
          value="Helmond Sport O17"
          checked={teamFilter === "Helmond Sport O17"}
          onChange={(e) => setTeamFilter(e.target.value)}
        />
        Alleen Helmond Sport Spelers
      </label>
      <label>
        <input
          type="radio"
          name="teamFilter"
          value=""
          checked={teamFilter === ""}
          onChange={(e) => setTeamFilter(e.target.value)}
        />
        Alle Spelers
      </label>
    </div>
  );
}